export function nextLevel(currentLevel, streak) {
  if (streak >= 3) return currentLevel + 1;     // raise difficulty
  if (streak === 0) return Math.max(1, currentLevel - 1);
  return currentLevel;
} 